import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithReauth } from "../utilities/refreshTokenUtility";

export const institutionApi = createApi({
  reducerPath: "institutionApi",
  
  baseQuery: createBaseQueryWithReauth(`${import.meta.env.VITE_BASE_API_URL}Institution/`),

  endpoints: (builder) => ({
    getAllInstitutions: builder.query({
      query: () => ({
        url: "GetInstitutions",
        method: "GET",
      }),
    }),

    getInstitutionById: builder.query({
      query: (id) => ({
        url: `GetInstitutionById?id=${id}`,
        method: "GET",
      }),
    }),

    addInstitution: builder.mutation({
      query: (body) => {
        return {
          url: "AddInstitution",
          method: "POST",
          body,
        };
      },
    }),

    updateInstitution: builder.mutation({
      query: ( body ) => {
        return {
          url: "UpdateInstitution",
          method: "PUT",
          body,
        };
      },
    }),
    deleteInstitution: builder.mutation({
      query: id => ({
        url: `DeleteInstitution?id=${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetAllInstitutionsQuery,
  useGetInstitutionByIdQuery,
  useAddInstitutionMutation,
  useUpdateInstitutionMutation,
  useDeleteInstitutionMutation,
} = institutionApi;

export default institutionApi.reducer;
